import { useSyncExternalStore } from 'react';

// The permanent sidebar is collapsible — an 81px rail or 248px expanded, kept in
// `localStorage` — so anything positioned beside it has to follow the live width. The
// full-mode Lift AI panel assumed 81, and with the sidebar expanded its left 167px sat
// underneath the nav.
//
// Same shape as `~/components/global/appBarHeight`: the layout publishes while mounted
// and resets on unmount, so a surface rendered outside the app shell reads 0 rather
// than a stale offset. The value is the desktop width — below `sm` the sidebar is a
// temporary overlay and consumers should use 0.
const DEFAULT_SIDEBAR_WIDTH = 0;

let sidebarWidth = DEFAULT_SIDEBAR_WIDTH;
const listeners = new Set<() => void>();

const emit = () => {
  for (const listener of listeners) listener();
};

export const publishSidebarWidth = (width: number): void => {
  if (width === sidebarWidth) return;
  sidebarWidth = width;
  emit();
};

export const resetSidebarWidth = (): void => {
  publishSidebarWidth(DEFAULT_SIDEBAR_WIDTH);
};

const subscribe = (listener: () => void): (() => void) => {
  listeners.add(listener);
  return () => listeners.delete(listener);
};

const getSnapshot = (): number => sidebarWidth;

export const useSidebarWidth = (): number =>
  useSyncExternalStore(subscribe, getSnapshot, () => DEFAULT_SIDEBAR_WIDTH);
